import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
export default function HomePage() {
  return (
    <main className="text-white">
      <Helmet>
        <meta
          name="description"
          content="Codexa builds innovative digital solutions including websites, apps, and cloud infrastructure."
        />
      </Helmet>

      {/* Hero Section with Background Image */}
      <section
        className="min-h-screen flex items-center justify-center px-6 text-center bg-cover bg-center relative"
        style={{ backgroundImage: "url('/background.jpeg')" }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-60 z-0" />

        <div className="relative z-10 max-w-3xl space-y-6">
          {/* Hero Title Animation */}
          <motion.h1
            initial={{ opacity: 0, y: -40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-4xl md:text-6xl font-bold leading-tight"
          >
            Welcome to <span className="text-indigo-500">Codexa</span>
          </motion.h1>

          {/* Hero Description Animation */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            className="text-lg md:text-xl text-gray-200"
          >
            Codexa is a digital transformation partner, empowering businesses through innovative solutions and next-gen technologies.
          </motion.p>

          {/* Explore Services Button Animation */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.8, duration: 0.6 }}
          >
            <NavLink
              to="/services"
              className="inline-block bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-6 py-3 rounded-full shadow-lg transition"
            >
              Explore Services
            </NavLink>
          </motion.div>
        </div>
      </section>
    </main>
  );
}
